import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { NavLink } from "react-router-dom"
import { formatCurrency } from "uikit"

const SocialSecurityCard = ({ id, type, personName, monthly_amount }) => {
  return (
    <Card>
      <Card.Content>
        <Grid style={{ position: "relative", height: "170px" }}>
          <Grid.Row columns={2} verticalAlign="top">
            <Grid.Column>
              <NavLink
                to={`/organize/income+benefits/benefits/${id}/${type.toLowerCase()}`}
                className="navlink"
              >
                <span className="GenericCard__LinkTitle">
                  Social Security
                  <Icon name="chevron right" size="small" />
                </span>
                <p className="greyed-text" />
              </NavLink>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="GenericCard__Balance">
                {formatCurrency(monthly_amount)}
              </p>
              <p className="greyed-text">{"per month"}</p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2} verticalAlign="bottom">
            <Grid.Column>
              <p className="greyed-text">{personName}</p>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="greyed-text">Government Benefit</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  )
}

export default SocialSecurityCard
